import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../store/auth/authActions';
import { useState } from 'react';
import { LogoutConfirmDialog } from '../../auth/logout-confirm-dialog';
import { StudentForm } from './student-form';
import { TutorForm } from './tutor-form';
import { RightText } from './right-text';
import { FinalStep } from './final-step';
import { ProfileType } from './profile-type';
import { Toaster } from 'react-hot-toast';

const CreateProfileWizard = () => {
    const dispatch = useDispatch();
    const [currentStep, setCurrentStep] = useState(0);
    const [type, setType] = useState(1);
    const [logoutOpen, setLogoutOpen] = useState(false);

    const confirmLogout = () => {
        setLogoutOpen(false);
        dispatch(logoutUser());
    };


    return (
        <>
        <div className="mx-auto flex w-full">
            <Toaster />
            <div className={`px-4 sm:px-0 w-full xl:w-1/2 ${(currentStep >= 2 && currentStep <= 6) ? 'w-full flex' : ''}`}>
                <button className='lg:hidden absolute top-10 right-5 text-nt-blue' onClick={() => setLogoutOpen(true)}>Logout</button>
                {[0, 1].includes(currentStep) && <div className="mx-auto max-w-[500px]">
                    {currentStep === 0 && <ProfileType setCurrentStep={setCurrentStep} setType={setType} type={type} />}
                    {currentStep === 1 && <StudentForm setCurrentStep={setCurrentStep} />}
                </div>}
                {(currentStep >= 2 && currentStep <= 6) && <TutorForm currentStep={currentStep} setCurrentStep={setCurrentStep} />}
                {currentStep === 10 && <FinalStep type={type} />}
            </div>
            {([0, 1, 10].includes(currentStep) || type === 1) && 
                <div className="hidden lg:flex w-1/2 animate-bg-spin-1 bg-[length:400%_400%] items-center fix h-screen top-0 right-0 bg-gradient-to-br from-nt-blue to-nt-red" >
                    <button className='absolute top-5 right-5 text-white' onClick={() => setLogoutOpen(true)}>Logout</button>
                    <RightText />
                </div>
            }
        </div>

            <LogoutConfirmDialog
                open={logoutOpen}
                onClose={() => setLogoutOpen(false)}
                onConfirm={confirmLogout}
            />
        </>
    );
};
export { CreateProfileWizard };
